import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { selectedTeamSelector } from 'state/selectors/ui-state';
import useGitTeamSettings from '../../settings/views/GitSettings/GitTeamSettings/useGitTeamSettings';
import { useDebounceCallback } from '@react-hook/debounce';
import useQueryParams from 'components/hooks/useQueryParams';

const useTeamGitFilters = () => {
  const selectedTeam = useSelector(selectedTeamSelector);
  const teamId = selectedTeam?.id;
  const prevTeamId = useRef(teamId);
  const hasTeamChanged = prevTeamId.current !== teamId;

  const teamGitSettings = useGitTeamSettings({ teamId });
  const { updateQuery, getQueryParam } = useQueryParams();
  const isDrilldownMode = Boolean(getQueryParam('metric_name'));
  const isGitFiltersFromQs =
    !!getQueryParam('services') || !!getQueryParam('repositories');

  const updateGitTeamQueryParams = useDebounceCallback(() => {
    if (isDrilldownMode || !teamId || (!!isGitFiltersFromQs && !hasTeamChanged))
      return;

    prevTeamId.current = teamId;

    const { reposIds, servicesIds } = teamGitSettings;
    updateQuery({
      repositories: reposIds?.length ? reposIds.join(',') : null,
      services: servicesIds?.length ? servicesIds.join(',') : null
    });
  }, 50);

  useEffect(() => {
    updateGitTeamQueryParams();
  }, [teamId, isDrilldownMode]);
};

export default useTeamGitFilters;
